import {
  emitCustomEvent,
  useCustomEventListener,
} from 'infrastructure/hooks/utils';

interface ICallEndedEventDetails {
  patientGuid: string;
  callDuration: number;
}

const CALL_ENDED_EVENT_NAME = 'callEnded';

export const emitCallEndedEvent = ({
  callDuration,
  patientGuid,
}: ICallEndedEventDetails) => {
  emitCustomEvent<ICallEndedEventDetails>(CALL_ENDED_EVENT_NAME, {
    callDuration,
    patientGuid,
  });
};

export const useCallEndedEventListener = (
  callback: (event: CustomEvent<ICallEndedEventDetails>) => void,
) => {
  useCustomEventListener<ICallEndedEventDetails>(
    CALL_ENDED_EVENT_NAME,
    callback,
  );
};
